export default "__VITE_ASSET__Cgu7hNZs__"